module.exports = __webpack_public_path__ + "static/media/BROOBEE-CAKE.baa2114a.svg";